var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_368_2232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z",
    fill: "#626B79"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_368_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 0.0190012C8.35158 -0.903027 6.45145 -1.42859 4.42857 -1.42859C-1.88325 -1.42859 -7 3.68816 -7 9.99998C-7 16.3118 -1.88325 21.4286 4.42857 21.4286C6.45145 21.4286 8.35158 20.903 9.99986 19.981C11.6481 20.903 13.5483 21.4286 15.5712 21.4286C21.883 21.4286 26.9997 16.3118 26.9997 9.99998C26.9997 3.68816 21.883 -1.42859 15.5712 -1.42859C13.5483 -1.42859 11.6481 -0.903027 9.99986 0.0190012ZM8.37512 1.12091C7.16922 0.58411 5.83374 0.285767 4.42857 0.285767C-0.936479 0.285767 -5.28571 4.635 -5.28571 10.0001C-5.28571 15.3651 -0.936479 19.7143 4.42857 19.7143C5.83378 19.7143 7.1693 19.416 8.37523 18.8792C6.80666 17.6064 5.58195 15.9263 4.86213 14H-4.00002V12.5H4.41684C4.23729 11.6953 4.14258 10.8587 4.14258 9.99998C4.14258 9.3177 4.20237 8.64938 4.31699 7.99997H-4.00002V6.49997H4.68848C5.3748 4.36431 6.67234 2.50263 8.37512 1.12091ZM11.6245 18.8792C12.8304 19.416 14.1659 19.7143 15.5712 19.7143C20.9362 19.7143 25.2854 15.3651 25.2854 10.0001C25.2854 4.635 20.9362 0.285767 15.5712 0.285767C14.166 0.285767 12.8305 0.58411 11.6246 1.12091C13.3274 2.50263 14.6249 4.36431 15.3112 6.49997H24V7.99997H15.6827C15.7974 8.64938 15.8571 9.3177 15.8571 9.99998C15.8571 10.8587 15.7624 11.6953 15.5829 12.5H24V14H15.1376C14.4178 15.9263 13.1931 17.6064 11.6245 18.8792ZM13.2838 14C12.5615 15.5965 11.42 16.963 9.99986 17.959C8.57968 16.963 7.43827 15.5965 6.71596 14H13.2838ZM13.8182 12.5C14.03 11.7023 14.1429 10.8644 14.1429 10.0001C14.1429 9.31445 14.0718 8.64544 13.9367 7.99997H6.06298C5.92789 8.64544 5.85686 9.31445 5.85686 10.0001C5.85686 10.8644 5.96974 11.7023 6.18156 12.5H13.8182ZM13.4932 6.49997H6.50652C7.2064 4.68859 8.4336 3.13957 9.99986 2.04114C11.5661 3.13957 12.7933 4.68859 13.4932 6.49997Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.f2b3680b45d7dc4fa449e4825d9e30b2.svg";
export { ForwardRef as ReactComponent };